<template>
  <JLayoutSimple :content-scroll="true">
    <!-- 헤더 -->
    <template #header="{ isSidebarCollapsed, onSidebarToggle }">
      <JHeader
        logo-text="JWMS Portal"
        user-name="홍길동"
        :show-sidebar-toggle="true"
        :is-sidebar-open="!isSidebarCollapsed"
        @sidebar-toggle="onSidebarToggle"
      />
    </template>

    <!-- 사이드바 -->
    <template #sidebar="{ isSidebarCollapsed }">
      <JSidebarSimple
        :menu-items="sampleSidebarItems"
        :is-visible="!isSidebarCollapsed"
        @menu-click="handleMenuClick"
      />
    </template>

    <!-- 메인 콘텐츠 -->
    <template #content>
      <ExampleCrudPage />
    </template>
  </JLayoutSimple>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import JLayoutSimple from '@/components/templates/JLayoutSimple.vue'
import JHeader from '@/components/organisms/JHeader.vue'
import JSidebarSimple from '@/components/organisms/JSidebarSimple.vue'
import ExampleCrudPage from './ExampleCrudPage.vue'
import type { SidebarMenuItem, MenuClickEvent } from '@/types/sidebar-menu.types'

/**
 * 샘플 사이드바 메뉴
 */
const sampleSidebarItems: SidebarMenuItem[] = [
  { 
    label: '대시보드', 
    icon: 'chartBar',
    menuType: 'L',
    menuKey: 1,
    path: '/dashboard',
  },
  { 
    label: '고객사 관리', 
    icon: 'building',
    menuType: 'L',
    menuKey: 2,
    path: '/customers',
  },
  { 
    label: '재고 관리', 
    icon: 'package',
    menuType: 'F',
    menuKey: 3,
    children: [
      {
        label: '재고 현황',
        icon: 'packageCheck',
        menuType: 'L',
        menuKey: 31,
        path: '/inventory/status',
      },
      {
        label: '입고 관리',
        icon: 'arrowDownWideNarrow',
        menuType: 'L',
        menuKey: 32,
        path: '/inventory/receiving',
      },
      {
        label: '출고 관리',
        icon: 'arrowUpWideNarrow',
        menuType: 'L',
        menuKey: 33,
        path: '/inventory/shipping',
      },
    ],
  },
  { 
    label: '주문 관리', 
    icon: 'clipboardList',
    menuType: 'L',
    menuKey: 4,
    path: '/orders',
  },
]

/**
 * 메뉴 클릭 핸들러
 */
const selectedMenu = ref<SidebarMenuItem | null>(null)

function handleMenuClick(event: MenuClickEvent) {
  const menuItem = event.menuItem
  if (menuItem && menuItem.menuType === 'L') {
    selectedMenu.value = menuItem
    console.log('메뉴 선택:', menuItem.label, menuItem.path)
  }
}
</script>
